import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { chessUiMultiplayerCursors } from '../ui/chessUiMultiplayerCursors-sidecar'
import { EChessMessage } from './chessMessageIds'

export interface IChessMessageCursor {
  x: number
  y: number
}

export const messageId = EChessMessage.Cursor

export function write(m: IMessageWriter, d: IChessMessageCursor) {
  messageWriter.write8(m, messageId)
  messageWriter.write16(m, d.x)
  messageWriter.write16(m, d.y)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, messageId)
  let d: IChessMessageCursor = {
    x: messageWriter.read16(m),
    y: messageWriter.read16(m),
  }
  return d
}

export function test() {
  let ex: IChessMessageCursor = {
    x: 120,
    y: 110,
  }
  messageWriter.test('cursor', ex, write, read)
}

export function process(
  m: IMessageWriter,
  isFromHost: boolean,
  fromId: number,
) {
  let msg = read(m)
  let cur = chessUiMultiplayerCursors.findByMultiIdSafe(fromId)
  if (cur) {
    chessUiMultiplayerCursors.networkRecieveStartLerpToXY(cur, msg.x, msg.y)
  }
}

export function sendMessageToOthers(msg: IChessMessageCursor) {
  websockets._sendMessageToOthers(write, msg)
}
